import PopoverController                             from '../../frontend/controllers/popover_controller'
import { disableElement, enableElement, isDisabled } from '../../frontend/support/helpers'

export default class extends PopoverController {

  static targets = [
    ...super.targets,
    'button'
  ]

  static values = {
    ...super.values,
    timeout:   Number
  }

  static classes = [
    'loading'
  ]

  initialize() {}

  connect() {
    this.updateIfOpen()
  }

  // ==== Controllers

  // ==== Actions

  afterToggle(event) {
    super.afterToggle(event)
    if (this.isLoading && event.newState === 'closed' && !this.anyModalOpen) this.show()
  }

  loading({ currentTarget }) {
    this.element.classList.add(this.loadingClass)

    for (const button of this.buttonTargets) {
      if (button !== currentTarget) {
        button.dataset.wasDisabled = isDisabled(button)
      }
    }

    // Small timeout to allow the buttons to serialize and perform its action
    // before disabling.
    setTimeout(() => {
      for (const button of this.buttonTargets) {
        if (button !== currentTarget) {
          disableElement(button)
        }
      }
    }, 13)
  }

  loaded({ currentTarget }) {
    for (const button of this.buttonTargets) {
      if (button !== currentTarget) {
        if (button.dataset.wasDisabled !== 'true') {
          enableElement(button)
        }
        delete button.dataset.wasDisabled
      }
    }
    this.element.classList.remove(this.loadingClass)
  }

  // ==== Getters

  get isLoading() {
    return this.element.classList.contains(this.loadingClass)
  }

  get anyModalOpen() {
    return !!document.querySelector('.c-modal.-state-open')
  }

  // ==== Setters

  // ==== Private

  update() {
    super.update()

    this.popoverTarget.style.minWidth = `${this.anchorRect.width}px`
  }

  // ==== Channels

}
